<template>
  <div v-show="open" class="modal" :class="{ visible: open }">
    <div class="modal__overlay" @click="closeModal()"></div>
    <div class="modal__body" :style="modalStyleElement">
      <div class="modal__body__close" @click="closeModal()">
        <svg class="icon-close">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close-icon"></use>
        </svg>
      </div>
      <div class="modal__content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  props: {
    bgImage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      modalBodyStyle: {
        top: 0,
      },
      open: false,
    };
  },
  computed: {
    modalStyleElement() {
      if (this.bgImage) {
        return { top: this.modalBodyStyle.top, backgroundImage: `url(${this.bgImage})` };
      } else {
        return { top: this.modalBodyStyle.top };
      }
    },
  },

  created() {
    document.onkeydown = (evt) => {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        this.open = false;
      }
    };
  },

  mounted() {
    window.eventBus.$on('openVideoModal', () => {
      this.open = true;
    });
  },

  methods: {
    closeModal() {
      this.$parent.$emit('closeModal');
      this.$emit('close-modal');
      this.open = false;
      if (this.$children[0].player) {
        this.$children[0].player.stopVideo();
      }
    },

    onModalOpen() {
      // TODO: add modal fade in animation
      this.modalBodyStyle.top = `${window.pageYOffset}px`;
    },
  },
};
</script>
